

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AbstractItemModel } from '@/models/items/abstract-item-model';
import { GenericItem } from '@/models/items/generic-item-model';
import { ProductItem } from '@/models/items/product-item-model';
import { UploadUtils } from '@/utils/upload-utils';

import firebase from 'firebase/app';
import 'firebase/functions';

@Component({})
export default class AbstractAddItem_Step2 extends Vue {
  public uploadedImages: string[] = [];

  @Prop(Object) public item: AbstractItemModel;
  @Prop(Object) public lastStepData: any;

  public images: string[] = [];
  lastUrl = '';

  created() {
    if (this.item.imageURL) {
      this.images.push(this.item.imageURL);
    }

    if (this.$route.query.title) {
      this.item.title = this.$route.query.title as string;
    }
    if (this.$route.query.url) {
      this.item.url = this.$route.query.url as string;
    }
    if (this.$route.query.image) {
      (this.$route.query.image as string[]).forEach(i => {
        this.images.push(decodeURIComponent(i))
      });
      this.setSelectedImage(this.$route.query.image[0]);
    }
  }

  public setSelectedImage(image: string) {
    this.item.imageURL = image;
    // TODO: why needed?
    this.$forceUpdate();
  }

  public isSelectedImage(image: string) {
    return this.item.imageURL === image;
  }

  get allImages() {
    return [...this.images, ...this.uploadedImages];
  }

  public onFileChange(e: any) {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) {
      return;
    }
    UploadUtils.uploadImageToFirebaseFromFile(files[0]).then(
      (imageURL: string) => {
        this.setSelectedImage(imageURL);
        this.uploadedImages.push(imageURL);
      }
    );
  }

  public clickFileButton() {
    document.getElementById('fileUploadButton').click();
  }

  isFormValid(): boolean {
    return true;
  }

  public async onSubmit() {
    const isValid = (await this.$validator.validate()) && this.isFormValid();

    if (isValid) {
      if (this.item.imageURL && !UploadUtils.isUploadedImage(this.item.imageURL)) {
        const imageURL = await UploadUtils.uploadImageToFirebaseFromUrl(this.item.imageURL);
        this.item.imageURL = imageURL;
      }

      this.$emit('go-to-next-step', {
        item: this.item
      });
    }
  }

  imageOnLoad(e: any) {
    if (e.target.naturalHeight < 100 || e.target.naturalWidth < 100) {
      this.images = this.images.filter((i) => i !== e.target.src);
    }
  }
  urlChange(e: any) {
    let url = e;
    if (e.clipboardData) {
      const self = this;
      e.clipboardData.items[0].getAsString(self.processUrlChange);
    } else if (e.target) {
      this.processUrlChange(e.target.value)
    } else {
      this.processUrlChange(e)
    }
  }

  processUrlChange(url: string) {
    if (!url) {
      return;
    }
    if (url == this.lastUrl) {
      return;
    }
    this.lastUrl = url;
    console.log('getting metadata');

    const getMetadata = firebase.functions().httpsCallable('app/getMetadata');
    return getMetadata({url: this.item.url}).then((result) => {
      if (!this.item.title) {
        this.item.title = result.data.title;
      }
      result.data.images.all.forEach((element: any) => {
        let image = element.src;
        if (image.indexOf('http') == -1) {
          image = this.item.url + image;
        }
        this.images.push(image);
      });
      this.$forceUpdate();
    });
  }
}
